import Button from '@/common/components/base/button/Button';
import { useRef, useState } from 'react';
import ReactCrop, { convertToPixelCrop, Crop } from 'react-image-crop';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';
import RotateImageIcon from '@/common/assets/icons/rotateImage.svg?react';
import { cropImage } from '@/common/components/imageGallery/utils/cropImage';
import { getRotatedImage } from '@/common/components/imageGallery/utils/rotateImage';
import { createPortal } from 'react-dom';
import 'react-image-crop/dist/ReactCrop.css';
import { EditImagePropsType } from '@/common/components/imageGallery/components/editImage/EditImage.type';

const EditImage = ({ image, onClose, onSave }: EditImagePropsType) => {
  const [imageUrl, setImageUrl] = useState(image);
  const [crop, setCrop] = useState<Crop>(initialCrop);
  const imageRef = useRef<HTMLImageElement>(null!);
  const canvasRef = useRef(null!);

  const showRotatedImage = async (rotate: number) => {
    const rotatedImageUrl = await getRotatedImage(
      imageUrl,
      canvasRef.current,
      rotate,
    );
    if (rotatedImageUrl) {
      setImageUrl(rotatedImageUrl);
      setCrop(initialCrop);
    }
  };

  const saveNewItem = async () => {
    const newImage = await cropImage(
      imageRef.current,
      convertToPixelCrop(crop, imageRef.current.width, imageRef.current.height),
      canvasRef.current,
    );

    if (newImage) {
      onSave(newImage);
    }
  };

  return createPortal(
    <Box
      className={css({
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'black',
      })}
    >
      <canvas ref={canvasRef} style={{ display: 'none' }} />
      <Box
        className={css({
          mx: 'auto',
          width: '90%',
          maxHeight: '70%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          maxWidth: 'maxContainer',
          m: 'auto',
          overflow: 'auto',
        })}
      >
        <ReactCrop keepSelection crop={crop} onChange={(_, c) => setCrop(c)}>
          <img
            alt=""
            ref={imageRef}
            crossOrigin="anonymous"
            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
            src={imageUrl}
          />
        </ReactCrop>
      </Box>
      <Box
        className={css({
          height: '10%',
          backgroundColor: 'black',
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          px: '2rem',
          maxWidth: 'maxContainer',
          m: 'auto',
        })}
      >
        <Button
          className={css({ color: 'white' })}
          variant="text"
          onClick={onClose}
        >
          انصراف
        </Button>
        <Button
          className={css({ color: 'white' })}
          variant="text"
          onClick={() => {
            showRotatedImage(-90);
          }}
        >
          <RotateImageIcon />
        </Button>
        <Button
          className={css({ color: 'white' })}
          variant="text"
          onClick={saveNewItem}
        >
          ذخیره
        </Button>
      </Box>
    </Box>,
    document.body,
  );
};

export default EditImage;

const initialCrop: Crop = {
  unit: '%',
  x: 2,
  y: 2,
  width: 96,
  height: 96,
};
